import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { usePunditUserContext } from "@circle-react/contexts";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Loader } from "@circle-react-uikit/Loader";

export const NoPostsFound = () => {
  const { isLoading, currentCommunityMember } = usePunditUserContext();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      className={classNames("space__gated locked-pane !rounded-2xl")}
      data-testid="post_section"
    >
      <Typography.TitleLg as="h2">{t("no_posts_to_show")}</Typography.TitleLg>
      {!!currentCommunityMember?.is_admin && (
        <p>
          {t("homepage_admin_no_posts_description_part_1")}
          <br />
          <a
            href="https://community.circle.so/c/spaces/spaces"
            target="_blank"
            rel="noreferrer"
          >
            {t("homepage_admin_no_posts_description_part_2")}
          </a>
        </p>
      )}
    </div>
  );
};
